import {firestoreAction} from "vuexfire";
import {db} from "@/plugins/db";
import * as firebase from "firebase";
import {ActivityCategoryInterface, ActivitySubCategoryInterface, ActivityClassInterface, ActivityInterface} from "@/models/Activity";


const initPageState = () => {
    // @ts-ignore
    return {
        // @ts-ignore
        ActivityCategory: [],
        // @ts-ignore
        ActivitySubCategory: [],
        // @ts-ignore
        clases: [],

        // @ts-ignore
        activity: [],
    };
};

export default {
    namespace: true,
    state: initPageState(),
    actions: {
        bindCategories: firestoreAction(({bindFirestoreRef}) => {
            return bindFirestoreRef('ActivityCategory', db.collection('ActivityCategory').orderBy('createdAt', 'desc'))
        }),

        bindSubCategory: firestoreAction(({bindFirestoreRef}) => {
            return bindFirestoreRef('ActivitySubCategory', db.collection('ActivitySubCategory'))
        }),

        bindClases: firestoreAction(({bindFirestoreRef}, order) => {
            return bindFirestoreRef('clases', db.collection('clases').orderBy('createdAt', order))
        }),

        bindActivity: firestoreAction(({bindFirestoreRef}, payload) => {
            return bindFirestoreRef('activity', db.doc('clases/' + payload.id).collection('activity').orderBy('order', payload.order))
        }),

        createCategory: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const category: ActivityCategoryInterface = {
                title: payload.title,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            // @ts-ignore
            return db.collection('ActivityCategory').add(category).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),

        createSubCategory: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const Subcategory: ActivitySubCategoryInterface = {
                title: payload.title,
                category: payload.category,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            // @ts-ignore
            return db.collection('ActivitySubCategory').add(Subcategory).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),

        createClases: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const CLASE: ActivityClassInterface = {
                subCategory: payload.subCategory,
                type: payload.type,
                background: payload.background,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            // @ts-ignore
            return db.collection('clases').add(CLASE).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),
        createClasesActivity: firestoreAction(({commit}, payload,) => {
            commit('setLoading', true);
            const CLASE: ActivityInterface = {
                exam: payload.exam,
                order: parseInt(payload.order),
                title: payload.title,
                activities: payload.activities,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            // @ts-ignore
            return db.doc('clases/' + payload.path).collection('activity').add(CLASE).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),

        addActivity: firestoreAction(({commit}, payload,) => {
            commit('setLoading', true);
            const activities: any[] = payload.data;
            activities.forEach((e: any) => {
                return db.doc('clases/' + payload.paths.path).collection('activity')
                    .doc(payload.paths.path2)
                    .collection('activities')
                    .add({
                        ...e,
                        createdAt: firebase.firestore.FieldValue.serverTimestamp()
                    })
            });
            commit('setLoading', false);

        }),

        editActivity: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            return db
                .doc('clases/' + payload.paths.path)
                .collection('activity')
                .doc(payload.id)
                .update(payload.data)
                .then(() => {
                    commit('setLoading', false);
                }).catch((e) => {
                    alert(e);
                    commit('setLoading', false);
                })
        }),
        deleteActivity: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            return db
                .doc('clases/' + payload.path)
                .collection('activity')
                .doc(payload.id)
                .delete()
                .then(() => {
                    commit('setLoading', false);
                }).catch((e) => {
                    alert(e);
                    commit('setLoading', false);
                })
        }),

        createdHistoryClass : firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const data = {
                ...payload,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };

            return db.collection('HistoryClass').add(data).then(() => {
                commit('setLoading', false);

            }).then(() => {
                commit('setLoading', false);

            })

        }),

        updateClassUser: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            return db.doc('userDetails/' + payload.path).update(payload.data)
                .then(() => {
                    commit('setLoading', false);
                }).catch(() => {
                    commit('setLoading', false);
                })
        })

    },
    getters:{
        claseAductos(state: any){
            return state.clases.filter((e: any) => e.type == 'ADULTOS')
        },
        claseNiños(state: any){
            return state.clases.filter((e: any) => e.type == 'NIÑOS')
        }
    }

}